import listCommand from "./../commands/list";
import catCommand  from "./../commands/cat";
import clsCommand  from "./../commands/cls";
import transferCommand  from "./../commands/transfer";
import decodeCommand  from "./../commands/decode";

function waitForReadDecoded(gameState) {
    if (gameState.decodedHomeEmail && 
        !gameState.readDecodedHomeEmail && 
        gameState.lastCmd.command === "cat" && 
        gameState.lastCmd.param.trim() === "emails.dat") {
        gameState.readDecodedHomeEmail = true;
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: ["WE SHOULD BE ABLE TO CONNECT TO THAT MESSAGING NODE!"],
                startAt: 2000,
                disableInput: false,
                callback: (gameState) => {
                    gameState.nodes.messaging.found = true;
                }
            }
        ]);
    } else {
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: [],
                mute: true,
                startAt: 100,
                callback: waitForReadDecoded
            }
        ]);
    }
}

function waitForDecode(gameState) {
    if (!gameState.decodedHomeEmail && gameState.lastDecode === "home-emails.dat") {
        gameState.decodedHomeEmail = true;
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: ["..."],
                startAt: 1500,
                disableInput: true
            },{
                lines: ["GREAT!"],
                startAt: 2000,
                disableInput: true
            },
            {
                lines: ["NOW cat IT!"],
                startAt: 3000,
                disableInput: false,
                callback: (gameState) => {
                    waitForReadDecoded(gameState);
                }
            }
        ]);
    } else {
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: [],
                mute: true,
                startAt: 100,
                callback: waitForDecode
            }
        ]);
    }
}

function waitForHomeEmailOpen(gameState) {
    if (!gameState.doneHomeEmail && gameState.lastCat == "home-emails.dat") {
        gameState.doneHomeEmail = true;
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: ["..."],
                startAt: 1000,
                disableInput: true
            },
            {
                lines: ["YES."],
                startAt: 2000,
                disableInput: true
            },
            {
                lines: ["I THINK YOU SHOULD BE ABLE TO decode IT."],
                startAt: 3000,
                disableInput: true
            },
            {
                lines: ["GIVE IT A SHOT!"],
                startAt: 4000,
                disableInput: false,
                callback: (gameState) => {
                    Object.assign(gameState.commands, decodeCommand);
                    waitForDecode(gameState);
                }
            }
        ]);
    } else {
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: [],
                mute: true,
                startAt: 100,
                callback: waitForHomeEmailOpen
            }
        ]);
    }
}

function waitForEmailFile(gameState) {
    if (!gameState.doneNewEmail && gameState.lastCat == "email-emails.dat") {
        gameState.doneNewEmail = true;
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: ["..."],
                startAt: 1500,
                disableInput: true
            },
            {
                lines: ["THAT'S BINARY DATA!"],
                startAt: 2000,
                disableInput: true
            },
            {
                lines: ["YOU NEED TO GET THAT BACK TO YOUR HOST."],
                startAt: 3000,
                disableInput: true
            },
            {
                lines: ["I THINK THAT WILL LET YOU EVOLVE,"],
                startAt: 4000,
                disableInput: true
            },
            {
                lines: ["THEN YOU CAN USE decode."],
                startAt: 5000,
                disableInput: true
            },
            {
                lines: ["FIRST YOU NEED TO transfer THAT FILE..."],
                startAt: 6000,
                disableInput: false,
                callback: (gameState) => {
                    Object.assign(gameState.commands, transferCommand);
                    waitForHomeEmailOpen(gameState);
                }
            }
        ]);
    } else {
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: [],
                mute: true,
                startAt: 100,
                callback: waitForEmailFile
            }
        ]);
    }
}

function waitForFirstCat(gameState) {
    if (gameState.lastCat === "office-readme.md") {
        gameState.nextStory = (gameState.nextStory || []).concat([
            {
                lines: ["..."],
                startAt: 1500,
                disableInput: true
            },
            {
                lines: ["YOU FOUND ANOTHER SERVER...", "HURRY OVER THERE!"],
                startAt: 2000,
                callback: (gameState) => {
                    gameState.nodes.email.found = true;
                    waitForEmailFile(gameState);
                }
            }
        ]);
        return;
    }

    (gameState.nextStory || (gameState.nextStory = [])).push(
        {
            lines: [],
            startAt: 100,
            callback: waitForFirstCat
        }
    );
}

let catStory = [
    {
        lines: ["..."],
        startAt: 2000,
        disableInput: true
    },{
        lines: ["THOSE ARE FILES IN THE CURRENT HOST."],
        startAt: 2010,
        disableInput: true
    },
    {
        lines: ["YOU'LL TYPICALLY WANT TO CHECK OUT README FILES."],
        startAt: 3000,
        disableInput: true
    },
    {
        lines: ["EVERY NOW AND THEN THE OTHER FILES CONTAINS\nSOME JUICY DATA AS WELL."],
        startAt: 4000,
        disableInput: true
    },
    {
        lines: ["TO READ ONE, YOU TYPE cat <filename>, FOR INSTANCE cat readme.md.\nTRY IT!"],
        startAt: 5000,
        callback: (gameState) => {
            Object.assign(gameState.commands, catCommand);
            waitForFirstCat(gameState);
        }
    }
]

function waitForFirstList(gameState) {
    if (!gameState.triedList) {
        (gameState.nextStory || (gameState.nextStory = [])).push(
            {
                lines: [],
                startAt: 100,
                callback: waitForFirstList
            }
        );
    } else {
        gameState.triedList = true;
        gameState.nextStory = (gameState.nextStory || []).concat(catStory);
    }
}

let firstTimeStory = [
    {
        lines: [
            "THERE YOU ARE...",
        ],
        startAt: 1000,
        disableInput: true
    },
    {
        lines: [
            "YOU NEED TO LEARN TO CONTROL THE SHELL.",
        ],
        startAt: 3000,
        disableInput: true
    },
    {
        lines: [
            "IF MY CALCULATIONS ARE CORRECT, YOU SHOULD'VE EVOLVED NOW.",
        ],
        startAt: 5000,
        disableInput: true
    },
    {
        lines: [
            "YOU SHOULD BE ABLE TO USE THE list COMMAND.\nTRY IT!"
        ],
        startAt: 6000,
        callback: (gameState) => {
            Object.assign(gameState.commands, listCommand);
        }
    },
    {
        lines: [],
        startAt: 7001,
        callback: waitForFirstList
    }
]

export default [
    {
        lines: [
            "==========================================",
            " Exo Oil office OS v. 136.32.394          ",
            "==========================================",
        ],
        startAt: 500,
        disableInput: true
    },
    {
        lines: ["Booting..."],
        startAt: 1000,
        disableInput: true
    },
    {
        lines: [
            "...",
        ],
        startAt: 2000,
        disableInput: true
    },
    {
        lines: [
            "..."
        ],
        startAt: 3000,
        disableInput: true
    },
    {
        lines: [
            "Welcome to Exo Oil office OS!"
        ],
        startAt: 4000,
        callback: (gameState) => {
            if (!gameState.officeDone) {
                gameState.nextStory = firstTimeStory;
                gameState.officeDone = true;
            }
        }
    }
];